var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 6.93488V4.00259C11.3335 3.61196 11.0913 3.26301 10.7241 3.12498L8.32829 2.22655C8.11735 2.14582 7.88298 2.14582 7.66943 2.22655L5.2736 3.12498C4.90641 3.26301 4.66423 3.61196 4.66423 4.00259V6.93488L1.94287 7.95832C1.57568 8.09373 1.3335 8.4453 1.3335 8.83592V11.612C1.3335 11.9661 1.53402 12.2917 1.85173 12.4505L4.41943 13.7344C4.68245 13.8672 4.99495 13.8672 5.25798 13.7344L8.00016 12.3646L10.7424 13.7344C11.0054 13.8672 11.3179 13.8672 11.5809 13.7344L14.1486 12.4505C14.4663 12.2917 14.6668 11.9661 14.6668 11.612V8.83592C14.6668 8.4453 14.4246 8.09634 14.0575 7.95832L11.3335 6.93488ZM8.31266 7.84113V5.29165L10.7085 4.46613V7.0078L8.31266 7.84113ZM5.29183 3.78644L8.00016 2.77082L10.7085 3.78644V3.79165L8.00016 4.74478L5.29183 3.78905V3.78644ZM5.29183 4.46613L7.68766 5.29165V7.84113L5.29183 7.0078V4.46613ZM4.51058 13.0443L1.98975 11.7838V9.35415L4.51058 10.3776V13.0443ZM1.98975 8.64582V8.64061L4.8387 7.5729L7.65381 8.62759V8.65884L4.8387 9.80207L1.98975 8.64582ZM5.16683 10.3776L7.65381 9.36717V11.8021L5.16683 13.0469V10.3776ZM10.8335 13.0443L8.34652 11.8021V9.36978L10.8335 10.3802V13.0443ZM14.0106 11.7838L11.4897 13.0443V10.3776L14.0106 9.35415V11.7838ZM14.0106 8.64582L11.1616 9.80207L8.34652 8.65884V8.62759L11.1616 7.5729L14.0106 8.64061V8.64582Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.3333,
    height: 13.3333,
    fill: "white",
    transform: "translate(1.3335 1.33333)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "97120/static/media/Service.ac90caf67ea7d5f46f2a552403748915.svg";
export { ForwardRef as ReactComponent };